import React from 'react';
import './style.scss';

// StepperListItems Component
const StepperListItems = ({ items }) => (
  <div className="stepper-list-items">
    {items.map((item, index) => (
      <StepperListItem key={index} item={item} isSelected={item.isSelected} />
    ))}
  </div>
);

// StepperListItem Component
const StepperListItem = ({ item, isSelected }) => (
  <div className={`stepper-list-item ${isSelected ? 'selected' : ''}`}>
    <Icon src={item.icon} />
    <div className="text-container">
      <Text
        text={item.text}
        style={{ backgroundColor: item.backgroundColor, color: item.fontColor }}
      />
      <SubText text={item.subText} />
    </div>
  </div>
);

// Icon Component
const Icon = ({ src }) => <img className="icon" src={src} alt="icon" />;

// Text Component
const Text = ({ text, style }) => (
  <div className="text" style={style}>
    {text}
  </div>
);

// Text Component
const SubText = ({ text, style }) => (
  <div className="subtext" style={style}>
    {text}
  </div>
);

// Footer Component
const Footer = ({ footer }) => (
  <div className="footer">
    {footer.ctas.map((cta, index) => (
      <CTA key={index} cta={cta} />
    ))}
  </div>
);

// CTA Component
const CTA = ({ cta }) => (
  <a className="cta" href={cta.link} target="_blank" rel="noopener noreferrer">
    {cta.label}
  </a>
);

// StepperList Component
const StepperList = ({ section }) => (
  <div className="stepper-list">
    <h3 className="stepper-list-header">{section.title}</h3>
    <StepperListItems items={section.listItems} />
    {section.footer && <Footer footer={section.footer} />}
  </div>
);

export default StepperList;
